import { nb } from "./nb";

type Leaves<T, P extends string = ""> = {
  [K in keyof T & string]: T[K] extends string ? `${P}${K}` : Leaves<T[K], `${P}${K}.`>;
}[keyof T & string];

/** Every valid dotted message key, e.g. `"nav.overview"`. */
export type MessageKey = Leaves<typeof nb>;

export type MessageParams = Record<string, string | number>;

function lookup(key: string): string | undefined {
  let node: unknown = nb;
  for (const part of key.split(".")) {
    if (typeof node !== "object" || node === null) return undefined;
    node = (node as Record<string, unknown>)[part];
  }
  return typeof node === "string" ? node : undefined;
}

/** Translate a message key and replace `{name}` placeholders with `params`. */
export function t(key: MessageKey, params?: MessageParams): string {
  const template = lookup(key) ?? key;
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in params ? String(params[name]) : match,
  );
}
